import React, { Component } from "react";
import { MnemoLoading, Title, BoxInfo, SuccessNotification } from "components/misc";
import { adminService, dateHelper, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container, Row, Col, Button } from "design-react-kit";
import { withRouter } from "react-router-dom";
import { ROUTES } from "const";

class LessonActivityArchive extends Component {
  state = {
    loading: true,
    rndKey: 0,
    payload: [],
    currentPayload: [],
  };

  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "aa",
        Header: "AA",
        accessor: "aa",
      },
      {
        id: "company",
        Header: "Università",
        accessor: "company",
      },
      {
        id: "courseType",
        Header: "Tipo di corso",
        accessor: "courseType",
      },
      {
        id: "dateCreation",
        Header: "Data creazione",
        accessor: (row) => {
          return row.dateCreation ? dateHelper.toITDateTime(row.dateCreation) : "";
        },
      },
      {
        id: "folderNumber",
        Header: "Numero studenti",
        accessor: "folderNumber",
      },
      {
        id: "status",
        Header: "Stato",
        accessor: "status",
      },
    ],
    actions: [
      {
        id: "copyUrl",
        accessor: "id",
        label: "Copia link",
        icon: "it-copy",
        hidden: (row) => row.status !== "disponibile",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.copyUrl(value);
        },
      },
      {
        id: "download",
        accessor: "id",
        label: "Scarica",
        icon: "it-download",
        hidden: (row) => row.status !== "disponibile",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.download(value);
        },
      },
    ],
  };

  refreshTimeout = null;

  //--- ---

  componentDidMount() {
    this.loadRemote();
  }

  componentWillUnmount() {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
  }

  loadRemote() {
    this.setState({ loading: true });

    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }

    adminService
      .getLessonActivityArchives()
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.archives).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          currentPayload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---

        this.refreshTimeout = setTimeout(() => {
          this.loadRemote();
        }, 60000);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            currentPayload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
          });

          this.refreshTimeout = setTimeout(() => {
            this.loadRemote();
          }, 60000);
        }
      });
  }

  download(id) {
    adminService.downloadLessonActivityArchive(id).then(({ data }) => {
      window.open(data.payload.url, "_blank");
    });
  }

  copyUrl(id) {
    adminService.downloadLessonActivityArchive(id).then(({ data }) => {
      const url = data.payload.url;
      navigator.clipboard
        .writeText(url)
        .then(() => {
          SuccessNotification.render("Link copiato!", "");
        })
        .catch((error) => {
          console.log(error);
          networkErrorHelper.notify(error);
        });
    });
  }

  render() {
    const { loading, currentPayload, rndKey } = this.state;

    const isJobRunning = currentPayload.some((row) => row.status === "in_lavorazione");

    return (
      <>
        <Title>Archivio Tirocini Diretti</Title>

        <hr />
        <section className="my-4">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : (
            <Container>
              <Row className="my-2 align-items-center">
                <Col>
                  <Button
                    className="mx-1 float-right"
                    color="primary bg-dark"
                    onClick={() => this.props.history.push(ROUTES.LESSON_ACTIVITY_ARCHIVE_FORM)}
                    disabled={isJobRunning}
                  >
                    Genera nuovo
                  </Button>
                </Col>
              </Row>

              <MTable key={rndKey} tableData={currentPayload} tableConfig={this.tableConfig} />
            </Container>
          )}

          {currentPayload.length === 0 && (
            <BoxInfo key="nrp-1" className="my-3">
              <div className="small text-info">Non ci sono dati da mostrare.</div>
            </BoxInfo>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(LessonActivityArchive);
